/* eslint semi:0 */
/**
 * The idea is that this file should be generated at deploy time and
 * statically delivered to the client. We're not there yet, so it is
 * hard-coded :(
 */
export const SELECTORS = {
  NAVBAR_SOCIAL_COMPONENT: '.header-post-actions',
  SHARE_COMPONENT: '.share-component',
  SHARE_COVER_COMPONENT: '.share-component--post-cover',
  BOTTOM_SOCIAL_ICONS: '.bottom-social',
  SEARCH_COMPONENT: '.search-comp',
  MONTI_BODY: '.Jwplayer-container',
  USER_MENU_DROPDOWN: '.user-menu.has-dropdown',
  POST_METADATA_STATS: '.post-metadata__stats',
  COMMUNITY_DISCLAIMER: '.community-disclaimer',
  SITE_HEADER: '#site-header',
  NAVIGATION: '.mobile-nav-main-wrapper',
  SLIDE: '.slide',
  SLIDE_CONTAINER: '.slideshow__slide',
  POST_BODY_SELECTOR: '.post-body',
  POST_BODY_WRAP_SELECTOR: '.post-body-wrap',
  POST_CONTENT_SELECTOR: '.post-content',
  SOCIAL_BAR__COVER: '.social-bar--cover',
  SOCIAL_BAR__HEADER: '.social-bar--header',
  SOCIAL_BAR__DETAILS: '.social-bar--details',
  SOCIAL_BAR__BOTTOM: '.social-bar--bottom',
  SLIDESHOW_POST_METADATA: '.post-metadata',
  PLAYBYZZ_CONTAINER: '.pb_feed',
  SCRIBBLELIVE_CONTAINER: '.scrbbl-embed[data-src]',
  POST_COVER: '.post-cover',
  MAIN_SIDENAV: '.main-sidenav',
  MAIN_SIDENAV_TOGGLE: '.main-sidenav-toggle',
  MAIN_SIDENAV_CHECKBOX: '#main-sidenav-checkbox',
  EDITION_DROPDOWN: '.edition-component__dropdown',
  EDITION_COMPONENT: '.edition-component',
  PAGE_WRAP: '.page-wrap',
  HEADER_AD_UNIT: '.ad[data-slot-id="Top"]',
  MODAL: '#root-dialog',
  MODAL__MOUNT_POINT: '.modal__mount-point',
  MODAL__CLOSE_BUTTON: '.modal__close',
  POST_AFTER: '.post-after',
  TOP_POSTS_AFTER_POST: '.top-posts-after-post',
  SECTION_TITLE_TOP_POSTS_AFTER_POST: '.section-title--top-posts-after-post',
  TOP_POSTS_SIDE_BAR: '.top-posts-side-bar',
  SECTION_TITLE_TOP_POSTS_SIDE_BAR: '.section-title--top-posts-side-bar',
  TOP_POSTS_AFTER_POST_ITEM_IMAGE_CONTAINER: '.top-posts-after-post__item__image-container',
  TOP_POSTS_SIDE_BAR_ITEM_IMAGE_CONTAINER: '.top-posts-side-bar__item__image-container',
  NEWSCORP_EMBED_CONTAINER: '.newscorp-container',
  AD: '.ad',
  TABOOLA_WIDGET_CONTAINER: '.nm-taboola-widget',
  POST_ARTICLE_TITLE: '.post-article__post-title',
  SCHEDULE: '.schedule-component',
  SCHEDULE_IN_FIXTURES_PAGE: '.schedule-component--scores',
  LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE: '.league-selection-scores',
  TV_SCHEDULE_CHANNEL_SELECTION: '.tv-schedule__channel-selection',
  TV_SCHEDULE_CHANNEL: '.tv-schedule__channel-schedule',
  FANVOICE_CONTAINER: '.fanvoice',
  YAHOO_FANTASY: '.fantasy-mount-point',
  FACEBOOK_BOT: '.facebook-bot-mount-point',
  FRESH8_MOUNT_POINT: '.fresh8-mount',
  FRESH8_FLOATING: '.fresh8-floating-container',
  SCORES_TABLE: '.scores-table',
  WRITERS_ARTICLE_BUTTON: '.writers__write-article-button',
  RECOMMENDED_VIDEOS_CONTAINER: '.recommended-videos',
  USER_STATS: '.user-stats-mount-point',
  ADMIN_PANEL: '.admin-panel-mount-point',
  MESSAGE_USER: '.message-user-mount-point',
  RECOMMENDED_POSTS_INJECTED: '.recommendedPostsPlaceHolder',
}

const SCROLL_EVENTS_BASE_SELECTOR = '.scroll-anchor'
function prefixScrollAnchorSelector(strings, ...values) {
  return `${SCROLL_EVENTS_BASE_SELECTOR}${strings[0]}`
}
export const SCROLL_EVENTS_SELECTORS = {
  TITLE: prefixScrollAnchorSelector`.title`,
  BODY_START: prefixScrollAnchorSelector`.body-start`,
  SHARE_BUTTONS_BOTTOM: prefixScrollAnchorSelector`.share-buttons-bottom`,
  TOP_POSTS: prefixScrollAnchorSelector`.top-posts`,
  TABOOLA: prefixScrollAnchorSelector`.taboola`,
  PAGE_END: prefixScrollAnchorSelector`.page-end`,
  // mobile only
}

export const MOUNT_POINTS = {
  SHARE_COMPONENT: SELECTORS.SHARE_COMPONENT,
  NAVBAR_SOCIAL_COMPONENT: SELECTORS.NAVBAR_SOCIAL_COMPONENT,
  SHARE_COVER_COMPONENT: SELECTORS.SHARE_COVER_COMPONENT,
  BOTTOM_SOCIAL_ICONS: SELECTORS.BOTTOM_SOCIAL_ICONS,
  SEARCH_COMPONENT: SELECTORS.SEARCH_COMPONENT,
  MONTI_BODY: SELECTORS.MONTI_BODY,
  USER_MENU_DROPDOWN: SELECTORS.USER_MENU_DROPDOWN,
  POST_METADATA_STATS: SELECTORS.POST_METADATA_STATS,
  COMMUNITY_DISCLAIMER: SELECTORS.COMMUNITY_DISCLAIMER,
  SLIDE: SELECTORS.SLIDE,
  SLIDE_CONTAINER: SELECTORS.SLIDE_CONTAINER,
  MODAL__MOUNT_POINT: SELECTORS.MODAL__MOUNT_POINT,
  SCHEDULE_COMPONENT: SELECTORS.SCHEDULE,
  SCHEDULE_COMPONENT_IN_FIXTURES_PAGE: SELECTORS.SCHEDULE_IN_FIXTURES_PAGE,
  SOCIAL_BAR_COMPONENT__COVER: SELECTORS.SOCIAL_BAR__COVER,
  SOCIAL_BAR_COMPONENT__HEADER: SELECTORS.SOCIAL_BAR__HEADER,
  SOCIAL_BAR_COMPONENT__DETAILS: SELECTORS.SOCIAL_BAR__DETAILS,
  SOCIAL_BAR_COMPONENT__BOTTOM: SELECTORS.SOCIAL_BAR__BOTTOM,
  LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE:
    SELECTORS.LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE,
  TV_SCHEDULE_CHANNEL_SELECTION: SELECTORS.TV_SCHEDULE_CHANNEL_SELECTION,
  TV_SCHEDULE_CHANNEL: SELECTORS.TV_SCHEDULE_CHANNEL,
  FANVOICE_CONTAINER: SELECTORS.FANVOICE_CONTAINER,
  FRESH8_MOUNT_POINT: SELECTORS.FRESH8_MOUNT_POINT,
  YAHOO_FANTASY_MOUNT_POINT: SELECTORS.YAHOO_FANTASY,
  FACEBOOK_BOT_MOUNT_POINT: SELECTORS.FACEBOOK_BOT,
  FRESH8_FLOATING_MOUNT_POINT: SELECTORS.FRESH8_FLOATING,
  SCORES_TABLE: SELECTORS.SCORES_TABLE,
  USER_STATS: SELECTORS.USER_STATS,
  ADMIN_PANEL: SELECTORS.ADMIN_PANEL,
  MESSAGE_USER: SELECTORS.MESSAGE_USER,
  RECOMMENDED_VIDEOS_CONTAINER: SELECTORS.RECOMMENDED_VIDEOS_CONTAINER,
  RECOMMENDED_POSTS: SELECTORS.RECOMMENDED_POSTS_INJECTED,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/config/preRenderedSelectorsConfig.js